import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

const useStyles = makeStyles({
  root: {
    backgroundColor: "transparent",
    border: "none",
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  contenido: {
    padding: "0px",
  },
  link: {
    paddingLeft: "0px !important",
  },
});

function ListItemLink(props) {
  return <ListItem button component="a" {...props} />;
}

const ListaEnlacesMenu = ({ subItem }) => {
  const classes = useStyles();
  return (
    <Card className={classes.root} variant="outlined">
      <CardContent className={classes.contenido}>
        {
          //Se valida si tiene submenus
          subItem.children ? (
            <Typography
              gutterBottom
              variant="h5"
              component="h2"
              className="h2MenuName"
            >
              {subItem.title}
            </Typography>
          ) : (
            <Typography
              gutterBottom
              variant="h5"
              component="h2"
              className="h2MenuName"
            >
              <a
                style={{
                  fontWeight: "bolder",
                  textDecoration: "none",
                  paddingLeft: "20px",
                }}
                href={subItem.url}
              >
                {subItem.title}
              </a>
            </Typography>
          )
        }

        {subItem.children && (
          <List
            component="nav"
            aria-label="secondary mailbox folders"
            style={{ padding: "0px" }}
          >
            {subItem.children.map((subsubItem, index) => {
              return (
                <ListItemLink
                  key={`itemSubMenu-${index}`}
                  className={`itemSubmenu ${classes.link}`}
                  href={subsubItem.url}
                >
                  <ListItemText
                    primary={subsubItem.title}
                    className="h2SubMenuName"
                    style={{
                      lineHeight: "1.3rem",
                      padding: "0px",
                      margin: "0px",
                      color: "#000",
                    }}
                  />
                </ListItemLink>
              );
            })}
          </List>
        )}
      </CardContent>
    </Card>
  );
};

export default ListaEnlacesMenu;
